function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import Link from './Link';
import ArrowNext from '../Icons/ArrowNext';
import ArrowPrevious from '../Icons/ArrowPrevious';
import ArrowUp from '../Icons/ArrowUp';
import ArrowDown from '../Icons/ArrowDown';
import { px2rem, font, padding, margin, getSpacing, getDisplay } from '../../utils/helpers';
var StyledLink = styled.a(_templateObject(), function (_ref) {
  var theme = _ref.theme,
      variant = _ref.variant,
      isMini = _ref.mini,
      background = _ref.background,
      disabled = _ref.disabled,
      fullWidth = _ref.fullWidth;
  var text = theme.text,
      colors = theme.colors,
      arrowLink = theme.arrowLink;
  var shared = arrowLink.shared,
      standard = arrowLink.standard,
      mini = arrowLink.mini;
  var backgroundType = Link.getBackgroundType(background);
  var _shared$variant$backg = shared[variant][backgroundType],
      inactiveState = _shared$variant$backg.inactive,
      focusState = _shared$variant$backg.focus,
      activeState = _shared$variant$backg.active,
      disabledState = _shared$variant$backg.disabled;
  return _extends({
    display: 'inline-block',
    cursor: 'pointer',
    pointerEvents: disabled ? 'none' : undefined
  }, font(_extends({}, text.shared.bold, !isMini ? text.standard.xlarge : text.standard.xsmall)), padding(!isMini ? standard : mini), {
    backgroundColor: colors[background],
    color: !disabled ? colors[inactiveState.color] : colors[disabledState.color],
    textDecoration: !disabled ? inactiveState.textDecoration : disabledState.textDecoration,
    textDecorationColor: !disabled ? colors[inactiveState.textDecorationColor] : colors[disabledState.textDecorationColor],
    maxWidth: !fullWidth && px2rem(shared.maxWidth),
    whiteSpace: variant === 'previous' && 'nowrap',
    overflow: variant === 'previous' && 'hidden',
    textOverflow: variant === 'previous' && 'ellipsis',
    svg: _extends({
      position: 'relative',
      top: (variant === 'previous' || variant === 'next') && 1 || (variant === 'up' || variant === 'down') && 2
    }, margin({
      marginLeft: variant === 'previous' && -2 || variant === 'next' && (!isMini ? 8 : 6) || (variant === 'up' || variant === 'down') && (!isMini ? 10 : 8),
      marginRight: variant === 'previous' && (!isMini ? 8 : 6) || variant === 'next' && -2
    }), {
      path: {
        fill: !disabled ? colors[inactiveState.iconColor] : colors[disabledState.iconColor]
      }
    }),
    ':hover,:focus': {
      color: colors[focusState.color],
      textDecoration: focusState.textDecoration,
      textDecorationColor: colors[focusState.textDecorationColor],
      svg: {
        path: {
          fill: colors[focusState.iconColor]
        }
      }
    },
    ':active': {
      color: colors[activeState.color],
      textDecoration: activeState.textDecoration,
      textDecorationColor: colors[activeState.textDecorationColor],
      svg: {
        path: {
          fill: colors[activeState.iconColor]
        }
      }
    }
  });
}, getSpacing, getDisplay);
var ArrowLink = forwardRef(function (props, ref) {
  var theme = props.theme,
      children = props.children,
      variant = props.variant,
      mini = props.mini,
      rest = _objectWithoutPropertiesLoose(props, ["theme", "children", "variant", "mini"]);

  var arrowLink = theme.arrowLink;
  var icon;

  switch (variant) {
    case 'previous':
      icon = ArrowPrevious;
      break;

    case 'up':
      icon = ArrowUp;
      break;

    case 'down':
      icon = ArrowDown;
      break;

    case 'next':
    default:
      icon = ArrowNext;
  }

  return /*#__PURE__*/React.createElement(StyledLink, _extends({
    ref: ref,
    variant: variant,
    mini: mini
  }, rest), variant === 'previous' && React.createElement(icon, {
    size: !mini ? arrowLink.standard.icon.size : arrowLink.mini.icon.size
  }), children, variant !== 'previous' && React.createElement(icon, {
    size: !mini ? arrowLink.standard.icon.size : arrowLink.mini.icon.size
  }));
});
ArrowLink.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['next', 'previous', 'up', 'down']),
  href: PropTypes.string,
  disabled: PropTypes.bool,
  background: PropTypes.oneOf(['white', 'black', 'grey1', 'grey2', 'functionalDimmedSuccess', 'functionalDimmedError', 'functionalDimmedInfo', 'functionalDimmedAlert']),
  mini: PropTypes.bool,
  fullWidth: PropTypes.bool
} : {};
ArrowLink.defaultProps = {
  variant: 'next',
  href: undefined,
  disabled: false,
  background: 'white',
  mini: false,
  fullWidth: false
};
export default withTheme(ArrowLink);